import { render, staticRenderFns } from "./AudioCallCard.vue?vue&type=template&id=252db505&scoped=true&"
import script from "./AudioCallCard.vue?vue&type=script&lang=js&"
export * from "./AudioCallCard.vue?vue&type=script&lang=js&"
import style0 from "./AudioCallCard.vue?vue&type=style&index=0&id=252db505&scoped=true&lang=scss&"
import style1 from "./AudioCallCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252db505",
  null
  
)

export default component.exports